import { Component } from '@angular/core';

@Component({
  selector: 'app-award-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './award-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class AwardIconComponent {}
